import QuizPage from "./QuizPage";
import QuizResultPage from "./QuizResultPage";

export default {
    "quiz-page": QuizPage,
    "quiz-result-page": QuizResultPage
};
